import React, { Component } from 'react';
import { Pagination } from "react-bootstrap";
import { CSVLink } from "react-csv";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import Graph from './components/Graph';
import API from '../../services/API';
import { PAGE_LIMIT, PARAMS_NAME } from "./config";
import { handleFieldChange } from "../../Utils";

class AdkBannerHourly extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            partnerValues: [],
            params: [],
            paramsObj: {},
            report: [],
            graph: [],
            total: {},
            sortParam: null,
            sortOrder: 1,
            pagesTotal: 0,
            activePage: 1,
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
    }

    componentDidMount() {
        this.loadAffids();

        this.setState({ isLoading: true });

        API.AdkBanner.Report.get('hourly', { 'day': new Date().toISOString().split('T')[0] }, 'graph').then(({ graph }) =>
            this.setState({ graph, isLoading: false }));

    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        const paramIndex = this.state.paramsObj[sortParam];
        report.sort((objA, objB) => {
            const valueA = objA[paramIndex] ? objA[paramIndex] : 0;
            const valueB = objB[paramIndex] ? objB[paramIndex] : 0;

            if(valueA > valueB) return 1 * sortOrder;
            else if(valueA < valueB) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === 'subid') return this.loadSubids(filters);

        this.loadReport(filters, type);
    }

    loadAffids() {
        API.AdkBanner.Feeds.getIds()
            .then(affids => this.setState({ affidValues: affids }));
    }

    loadReport(filters, type) {
        Promise.all([
            API.AdkBanner.Report.get('hourly', filters, type),
            API.AdkBanner.Report.get('hourly', filters, 'graph')
        ]).then(([ { params, report, total }, { graph } ]) => {
            const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);
            const paramsObj = params.reduce((obj, param, index) => {
                obj[param] = index;

                return obj;
            }, {});
            const newState = { params, paramsObj, report, graph, total, activePage: 1, pagesTotal, isLoading: false };

            this.setState(newState)
        })
    }

    loadSubids(filters) {
        API.AdkBanner.Report.get('hourly', filters, 'subid').then(({ subids }) => {
            this.setState({ isLoading: false,  subidValues: subids })
        });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getExportCsvButton() {
        let headers = this.state.params.map(param => ({ key: param, label: PARAMS_NAME[param] }));

        return <CSVLink data={this.state.report} headers={headers} className="btn btn-primary">Export CSV</CSVLink>;
    }

    getGraph() {
        const { graph } = this.state;

        if(!graph.length) return;

        return <Graph data={graph} />;
    }

    getTable() {
        let { params, paramsObj, report, total, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table params={params} paramsObj={paramsObj} report={report} total={total} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>
    }

    render() {
        const { isLoading, affidValues, subidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="ADK Banner Hourly"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues} partnerValues={this.state.partnerValues}/>
                {this.getExportCsvButton()}

                {this.getGraph()}
                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default AdkBannerHourly;



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerHourly/index.js